<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список направление специальностей</h3>


      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="search" class="form-label col-md-2"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по коду и наименованию"
                       id="search"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(code)="data">
        <div class="sortable-container none"
             @click="onSortChanged('code')"
             :class="{'ascending': page.sort.code === 'ASC', 'descending': page.sort.code === 'DESC'}">
          Код
        </div>
      </template>
      <template #head(nameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('nameRu')"
             :class="{'ascending': page.sort.nameRu === 'ASC', 'descending': page.sort.nameRu === 'DESC'}">
          Наименование
        </div>
      </template>
      <template #head(eduArea)="data">
        <div>
          Область образование
        </div>
      </template>



      <template #cell(code)="data">
        {{ data.item.code }}
      </template>
      <template #cell(nameRu)="data">
        <a :href="`/dict/profession-directions/${data.item.id}`">
          {{ data.item.nameRu }}
        </a>
      </template>

      <template #cell(eduArea)="data">
        <a :href="`/dict/profession-directions/${data.item.id}`">
          {{ data.item.eduArea?.code }} {{ data.item.eduArea?.nameRu }}
        </a>
      </template>

    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import professionDirectionService from "@/services/professionDirectionService";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      page: {
        filter: {
          search: null
        },
        sort: {
          nameRu: null,
          code: 'ASC'
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'code', label: 'Код', sortable: true},
        {key: 'nameRu', label: 'Наименование', sortable: true},
        {key: 'eduArea', label: 'Область образование', sortable: false}
      ],
      items: []
    };
  },
  methods: {
    isAdmin() {
      return delegationService.isAdmin();
    },

    async reloadList() {
      this.isLoading = true;
      const response = await professionDirectionService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await professionDirectionService.deleteByUuid(item.uuid);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    }
  },
  mounted() {
    this.reloadList();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
